// Mock data for AM Carpentry website

export const companyInfo = {
  name: "AM Carpentry",
  tagline: "Crafting Quality, One Door at a Time",
  description: "With years of experience in precision door fitting and custom carpentry, we bring craftsmanship and attention to detail to every project.",
  phone: "07308191917",
  email: "ethanmasih09@gmail.com",
  address: "248 Thimblemill Road, B67 6LS"
};

export const services = [
  {
    id: 1,
    title: "Door Fitting & Installation",
    description: "Expert installation of interior and exterior doors with precision fitting and weatherproofing.",
    icon: "DoorClosed"
  },
  {
    id: 2,
    title: "Custom Door Frames",
    description: "Handcrafted door frames tailored to your exact specifications and architectural style.",
    icon: "Frame"
  },
  {
    id: 3,
    title: "Door Repairs & Adjustment",
    description: "Professional repair services for sticking doors, broken hinges, and alignment issues.",
    icon: "Wrench"
  },
  {
    id: 4,
    title: "Hardware Installation",
    description: "Expert installation of locks, handles, hinges, and security hardware for all door types.",
    icon: "Lock"
  },
  {
    id: 5,
    title: "Custom Woodwork",
    description: "Bespoke carpentry services including trim work, molding, and architectural details.",
    icon: "Hammer"
  },
  {
    id: 6,
    title: "Restoration Services",
    description: "Careful restoration of vintage and antique doors to preserve their original character.",
    icon: "Sparkles"
  }
];

export const portfolio = [
  {
    id: 1,
    title: "Commercial Storefront Installation",
    category: "Commercial Door Fitting",
    image: "https://customer-assets.emergentagent.com/job_build-showcase-148/artifacts/la6d8vts_Screenshot%202026-06-05%20at%202.05.33%E2%80%AFam.png",
    description: "Professional commercial door and frame installation for retail space"
  },
  {
    id: 2,
    title: "Custom Wooden Staircase",
    category: "Custom Woodwork",
    image: "https://customer-assets.emergentagent.com/job_build-showcase-148/artifacts/h6a2vwqe_Screenshot%202026-06-05%20at%202.06.12%E2%80%AFam.png",
    description: "Handcrafted wooden staircase with precision carpentry work"
  },
  {
    id: 3,
    title: "Outdoor Building Construction",
    category: "Frame Installation",
    image: "https://customer-assets.emergentagent.com/job_build-showcase-148/artifacts/onumcar9_Screenshot%202026-06-05%20at%202.06.41%E2%80%AFam.png",
    description: "Complete shed construction with door and window frame installation"
  },
  {
    id: 4,
    title: "Interior Panel Doors with Hardware",
    category: "Interior Door Fitting",
    image: "https://customer-assets.emergentagent.com/job_build-showcase-148/artifacts/q6z6nlg7_8b221dae-04f0-415f-8778-dee935d502f0.jpg",
    description: "Professional installation of grey panel doors with door closer mechanisms"
  },
  {
    id: 5,
    title: "Wooden Decking Installation",
    category: "Custom Woodwork",
    image: "https://customer-assets.emergentagent.com/job_build-showcase-148/artifacts/fje7syy7_23c0e9d0-6faf-4eee-988c-a96a8b4928a6.jpg",
    description: "Quality outdoor decking with precision carpentry and finishing"
  },
  {
    id: 6,
    title: "Kitchen Carpentry Work",
    category: "Custom Woodwork",
    image: "https://customer-assets.emergentagent.com/job_build-showcase-148/artifacts/ackxyokj_8b250647-a772-4f41-a38f-cfebc0c188cb.jpg",
    description: "Professional kitchen cabinet installation and finishing"
  },
  {
    id: 7,
    title: "Garden Building Construction",
    category: "Frame Installation",
    image: "https://customer-assets.emergentagent.com/job_build-showcase-148/artifacts/2ev7wtxh_2ae6434d-0102-49e2-8936-bb747eabc649.jpg",
    description: "Complete garden building with door and window installation"
  },
  {
    id: 8,
    title: "Residential Door Fitting",
    category: "Interior Door Fitting",
    image: "https://customer-assets.emergentagent.com/job_build-showcase-148/artifacts/mzidcdhp_Screenshot%202026-06-05%20at%202.07.41%E2%80%AFam.png",
    description: "Quality residential door installation with perfect frame alignment"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Deborah McMahon",
    role: "Homeowner",
    content: "Edwin came to fit skirting in our new kitchen extension. He also put in 3 window sills, door frame & door in downstream WC. Edwin's work was great, clearly a professional in his trade. On time & worked really hard to get the job done. Pleasant & polite. Highly recommend Edwin's work, will be using him again in the future.",
    rating: 5
  },
  {
    id: 2,
    name: "Charlie Kern",
    role: "Local Guide",
    content: "Edwin did a great job repairing my front door frame and rehanging the door. He showed up bang on time and got the job done quickly. Very skilled carpenter.",
    rating: 5
  },
  {
    id: 3,
    name: "Halima Akram",
    role: "Homeowner",
    content: "Edwin was very professional and made sure to make my vision come to life! He is very skilled, punctual and makes sure that the job is done to a great standard. Would definitely recommend.",
    rating: 5
  },
  {
    id: 4,
    name: "Stephen Clarke",
    role: "Homeowner",
    content: "Edwin and his partner fitted 5 oak doors for me they came on time done a brilliant job and left no mess highly recommend them.",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "What types of doors do you install?",
    answer: "We install all types of doors including interior doors, exterior doors, French doors, sliding doors, bifold doors, and custom-made doors. We work with wood, composite, and metal doors."
  },
  {
    id: 2,
    question: "How long does a typical door fitting take?",
    answer: "A standard door fitting typically takes 2-4 hours depending on the complexity. Custom installations or those requiring frame adjustments may take longer. We'll provide a time estimate during consultation."
  },
  {
    id: 3,
    question: "Do you provide a warranty on your work?",
    answer: "Yes, we provide a 2-year warranty on all our fitting and installation work. This covers workmanship and ensures your complete satisfaction with our services."
  },
  {
    id: 4,
    question: "Can you fix a door that's sticking or not closing properly?",
    answer: "Absolutely! Door repairs and adjustments are one of our specialties. We can fix sticking doors, alignment issues, broken hinges, and worn hardware."
  },
  {
    id: 5,
    question: "Do you offer free quotes?",
    answer: "Yes, we provide free, no-obligation quotes. Simply fill out our contact form or give us a call, and we'll schedule a convenient time to assess your project."
  }
];

export const pricingPackages = [
  {
    id: 1,
    name: "Standard Interior Door",
    price: "£50",
    description: "Installation of standard interior door",
    icon: "DoorClosed",
    popular: false
  },
  {
    id: 2,
    name: "Front/Exterior Door",
    price: "£120",
    description: "Installation of front or exterior door",
    icon: "Home",
    popular: true
  },
  {
    id: 3,
    name: "Fire Door",
    price: "£80",
    description: "Installation of fire safety door",
    icon: "Flame",
    popular: false
  },
  {
    id: 4,
    name: "Bi-fold/Sliding Door",
    price: "£220",
    description: "Installation of bi-fold or sliding door systems",
    icon: "Maximize2",
    popular: false
  },
  {
    id: 5,
    name: "Frame Installation",
    price: "£40",
    description: "New door frame installation",
    icon: "Frame",
    popular: false
  },
  {
    id: 6,
    name: "Frame Adjustment",
    price: "£30",
    description: "Adjustment of existing door frame",
    icon: "Wrench",
    popular: false
  },
  {
    id: 7,
    name: "Door Disposal",
    price: "£15",
    description: "Removal and disposal of old door",
    icon: "Trash2",
    popular: false
  }
];